import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// layouts

import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";

// views without layouts
import Landing from "views/Landing.js";
import Profile from "views/Profile.js";
// import Index from "views/Index.js";

import Error404Layout from "./views/error/ERROR404";
import Error403Layout from "./views/error/ERROR403";
import Error500Layout from "./views/error/ERROR500";
import ErrorLayout from "./views/error/ERROR";
import UnSubscribe from "./views/pages/UnSubscribe/Success";
import Succeeded from "./views/pages/Payment/Success/Success";

import * as serviceWorker from './serviceWorker';


// import Dashboard from "views/admin/Dashboard.js";


const isAuthenticated = () => {
  if (localStorage.getItem("token")) {
    return true;
  } else {
    return false;
  }
};

ReactDOM.render(
  isAuthenticated() ? (  
  <BrowserRouter>
    <Switch>
      <Route path="/admin" component={Admin} />
      <Route path="/success:identity" component={Succeeded} />
      <Route path="/support" render={() => window.location = "https://support.zippyops.com"} />
      <Route path="/docs" render={() => window.location = "https://docs.automatecis.com/"} />      
      <Route path={`/access_denied`} component={Error403Layout} />
      <Route path={`/something_went_wrong`} component={Error500Layout} />
      <Route path={`/unsubscribed`} component={ErrorLayout} />            
      <Redirect from="*" to="/admin" />
    </Switch>
  </BrowserRouter>
  ) : (
  <BrowserRouter>
    <Switch>
      <Route path="/auth" component={Auth} />
      <Route path="/landing" exact component={Landing} />
      <Route path="/" exact component={Landing} />
      <Route path={`/access_denied`} component={Error403Layout} />
      <Route path={`/something_went_wrong`} component={Error500Layout} />
      <Route path={`/unsubscribed`} component={ErrorLayout} /> 
      <Route path={`/unsubscribe`} component={UnSubscribe} /> 
      <Redirect from="*" to="/" />
    </Switch>
  </BrowserRouter>  
  ),
  document.getElementById("root")
);

serviceWorker.unregister();
